import { IntlShape } from 'react-intl';

import { AnnotationToolFeatureId } from '@verantos-dev/core-annotation-tool';

import { MetricAnnotatorUser } from './types/responseTypes';

export const getAllAnnotatorsOption = (
  formatMessage: IntlShape['formatMessage']
): MetricAnnotatorUser => ({
  id: 'all-annotators',
  label: formatMessage({ id: 'metrics.dashboard.annotatorDropdown.allAnnotators' }),
});

export const METRICS_TAG = 'metrics';

export const BATCH_PROGRESS_TAB_OPTIONS = ['chart', 'table'];

export interface MetricsViewOption {
  id: string;
  labelId: string;
}

// Order matches AC-3: Dashboard, Summary statistics, Encounter statistics, F1 score, Holidays.
// ids reuse the existing route path segments (AnnotationToolFeatureId.metrics*) so the
// project-detail Metrics tab's URLs stay consistent with the standalone /metrics/* routes.
export const METRICS_VIEW_OPTIONS: MetricsViewOption[] = [
  { id: AnnotationToolFeatureId.metricsDashboard, labelId: 'metrics.view.dashboard.label' },
  { id: AnnotationToolFeatureId.metricsSummary, labelId: 'metrics.view.summary.label' },
  {
    id: AnnotationToolFeatureId.metricsEncounterStats,
    labelId: 'metrics.view.encounterStats.label',
  },
  { id: AnnotationToolFeatureId.metricsIRRScore, labelId: 'metrics.view.irrScore.label' },
  { id: AnnotationToolFeatureId.metricsHolidays, labelId: 'metrics.view.holidays.label' },
];

export const DEFAULT_METRICS_VIEW = METRICS_VIEW_OPTIONS[0].id;
